import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { bubEvents } from 'shared/events/bub_events';

import styles from 'stylesheets/components/pill_array';

export function PillArray({ labels, size, trackingCategory, trackingLabel, altLastPillColor }) {
  if (_.isEmpty(labels)) {
    return null;
  }

  function trackClick(label) {
    if (_.isNil(label.id)) {
      bubEvents.track(trackingCategory, 'Clicked pill', {
        label: trackingLabel,
        value: label.displayName,
      });
    } else {
      bubEvents.track(trackingCategory, 'Clicked pill', {
        label: trackingLabel,
        value: label.displayName,
        id: label.id,
      });
    }
  }

  function renderPill(label, pillBodyClass) {
    const sizeClass = size === 'small' ? styles.small : styles.large;
    return (
      <div className={classNames(styles.pill, sizeClass)} key={label.displayName} data-testid='pill-array-pill'>
        <a
          href={label.url}
          className={classNames(styles.pillLink)}
          onClick={() => trackClick(label)}
          aria-label={label.displayName}
        >
          <div className={classNames(styles.pillBody, pillBodyClass, sizeClass)}>{label.displayName}</div>
        </a>
      </div>
    );
  }

  if (altLastPillColor) {
    return (
      <>
        {labels.slice(0, -1).map(label => renderPill(label, styles.pillBody))}
        {renderPill(_.last(labels), styles.pillBodyAlt)}
      </>
    );
  }
  return <>{labels.map(label => renderPill(label))}</>;
}

PillArray.propTypes = {
  labels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      displayName: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
  size: PropTypes.oneOf(['small', 'large']),
  trackingCategory: PropTypes.string.isRequired,
  trackingLabel: PropTypes.string,
  altLastPillColor: PropTypes.bool,
};

PillArray.defaultProps = {
  size: 'small',
  trackingLabel: 'Pill label',
  altLastPillColor: false,
};
